import { SelfScheduledPeriodCount } from "api/hooks/private/users/students/CountSelfSchedulePeriods";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers/PickersDay";
import { PaletteColor, useTheme } from "@mui/material/styles";
import { Dayjs } from "dayjs";

interface PropTypes extends PickersDayProps<Dayjs> {
    coursePeriodCount?: SelfScheduledPeriodCount;
    studentBookedDates?: string[];
    blockedDates?: Set<string>;
}

function CalendarDay(props: PropTypes) {
    const theme = useTheme();
    const { coursePeriodCount = [], studentBookedDates = [], blockedDates = new Set(), day, outsideCurrentMonth, ...other } = props;
    const periodCount = (coursePeriodCount as SelfScheduledPeriodCount)[day.format('YYYY-MM-DD')];
    const isBlocked = blockedDates.has(day.format('YYYY-MM-DD'));
    let color: PaletteColor | undefined = undefined;
    let backgroundImage: string | undefined = undefined;
    let backgroundColor: string | undefined = undefined;
    let textColor: string | undefined = undefined;

    // Priority 1: Check if blocked
    if (isBlocked) {
        backgroundColor = theme.palette.grey[400];
        textColor = theme.palette.grey[900];
        backgroundImage = `repeating-linear-gradient(
            45deg,
            ${theme.palette.grey[400]},
            ${theme.palette.grey[400]} 5px,
            ${theme.palette.grey[300]} 5px,
            ${theme.palette.grey[300]} 10px
        )`;
    }
    // Priority 2: Student already booked
    else if (studentBookedDates.includes(day.format('YYYY-MM-DD'))) {
        color = theme.palette.primary;
    }
    // Priority 3: Availability colors
    else if (periodCount?.course_periods_with_open_performance_slots >= 2) {
        color = theme.palette.success;
    } else if (periodCount?.course_periods_with_open_performance_slots > 0) {
        color = theme.palette.warning;
    } else if (periodCount?.total_course_periods > 0 && periodCount?.course_periods_with_open_performance_slots === 0) {
        color = theme.palette.error;
    }

    return (
        // <Badge
        //     key={props.day.toString()}
        //     overlap="circular"
        //     badgeContent={periodCount?.total_course_periods}
        //     color="info"
        // >
        <PickersDay
            {...other}
            outsideCurrentMonth={outsideCurrentMonth}
            day={day}
            sx={{
                backgroundColor: backgroundColor ?? color?.main,
                backgroundImage: backgroundImage,
                color: textColor ?? color?.contrastText ?? 'unset',
                position: 'relative',
            }}
        />
        // </Badge>
    );
}

export default CalendarDay;